import { put, takeLatest, all, select } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import MOActions, { moActionTypes } from '../actions/moActions';
import MOServices from '../services/moServices';

/**
 * @param action
 */
function* _createMO(action) {
  try {
    yield put(MOActions.createMOLoading(true));
    const mo = yield MOServices.createMO(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.CREATE_MO.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: ' Manufacturing Order successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(mo?.data);
      yield put(MOActions.createMOLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.createMOLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.createMOLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.CREATE_MO.ERROR, error));
  }
}

/**
 *
 */
function* createMO() {
  yield takeLatest(moActionTypes.CREATE_MO.REQUEST, _createMO);
}

/**
 * @param action
 */
function* _createMOAdjustment(action) {
  try {
    yield put(MOActions.createMOAdjustmentLoading(true));
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let moAdjustment;
    if (isV2Enabled) {
      moAdjustment = yield MOServices.createMOAdjustmentV2(action.payload);
    } else {
      moAdjustment = yield MOServices.createMOAdjustment(action.payload);
    }
    if (moAdjustment.success) {
      yield put(TrackerActions.trackAction(moActionTypes.CREATE_MO_ADJUSTMENT.SUCCESS, moAdjustment.data));
      action.callback(moAdjustment?.data?.[0]);
      yield put(MOActions.createMOAdjustmentLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: moAdjustment?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.createMOAdjustmentLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.createMOAdjustmentLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.CREATE_MO_ADJUSTMENT.ERROR, error));
  }
}

/**
 *
 */
function* createMOAdjustment() {
  yield takeLatest(moActionTypes.CREATE_MO_ADJUSTMENT.REQUEST, _createMOAdjustment);
}

/**
 * @param action
 */
function* _updateMO(action) {
  try {
    yield put(MOActions.updateMOLoading(true));
    const mo = yield MOServices.updateMO(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Manufacturing Order successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(mo?.manufacturing_order);
      yield put(MOActions.updateMOLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.updateMOLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(MOActions.updateMOLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO.ERROR, error));
  }
}

/**
 *
 */
function* updateMO() {
  yield takeLatest(moActionTypes.UPDATE_MO.REQUEST, _updateMO);
}

/**
 * @param action
 */
function* _updateMOOtherCharges(action) {
  try {
    yield put(MOActions.updateMOOtherChargesLoading(true));
    const moOtherCharges = yield MOServices.updateMOOtherCharges(action.payload);
    if (moOtherCharges.success) {
      yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO_OTHER_CHARGES.SUCCESS, moOtherCharges.data));
      notification.open({
        type: 'success',
        message: 'Manufacturing Order successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(moOtherCharges?.manufacturing_order);
      yield put(MOActions.updateMOOtherChargesLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: moOtherCharges?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.updateMOOtherChargesLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(MOActions.updateMOOtherChargesLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO_OTHER_CHARGES.ERROR, error));
  }
}

/**
 *
 */
function* updateMOOtherCharges() {
  yield takeLatest(moActionTypes.UPDATE_MO_OTHER_CHARGES.REQUEST, _updateMOOtherCharges);
}

/**
 * @param action
 */
function* _getMO(action) {
  try {
    MOActions.getMOSuccess(null);
    yield put(MOActions.getMOLoading(true));
    const {
      tenantId, moId, status, page, limit, searchKeyword, callback, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp, source, customerId, salesOrderNumber, isScheduled
    } = action;
    const mo = yield MOServices.getMO(tenantId, moId, status, page, limit, searchKeyword, sellerId, departmentId, fromDate, toDate, listScreen, isArchived, isWeightedAverage, scheduledStartDate, scheduledEndDate, isLinkedMrp, source, customerId, salesOrderNumber, isScheduled);
    yield put(MOActions.getMOSuccess(mo));
    if (callback) {
      callback(mo);
    }
    yield put(MOActions.getMOLoading(false));
  } catch (error) {
    yield put(MOActions.getMOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MO.ERROR, error));
  }
}

/**
 *
 */
function* getMO() {
  yield takeLatest(moActionTypes.GET_MO.REQUEST, _getMO);
}

/**
 * @param action
 */
function* _getMOById(action) {
  try {
    yield put(MOActions.getMOByIdLoading(true));
    const {
      tenantId, moId, costingMethod,
    } = action;
    const selectedMO = yield MOServices.getMO(tenantId, moId, '', '', '', '', '', '', '', '', false, '', ['fifo'].includes(costingMethod?.toLowerCase()));
    yield put(MOActions.getMOByIdSuccess(selectedMO?.result?.manufacturing_orders?.[0]));
    yield put(MOActions.getMOByIdLoading(false));
  } catch (error) {
    yield put(MOActions.getMOByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MO_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getMOById() {
  yield takeLatest(moActionTypes.GET_MO_BY_ID.REQUEST, _getMOById);
}

/**
 * @param action
 */
function* _updateMOStatus(action) {
  try {
    yield put(MOActions.updateMOStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const mo = yield MOServices.updateMOStatus(payload);

    if (mo.success) {
      if (mo.manufacturing_order.status?.toLowerCase() === 'in_progress') {
        notification.open({
          type: 'success',
          message: ' Manufacturing Order in progress ',
          duration: 4,
          placement: 'top',
        });
      } else {
        notification.open({
          type: 'success',
          message: ' Manufacturing Order status  updated successfully',
          duration: 4,
          placement: 'top',
        });
      }

      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.updateMOStatusLoading(false));
  } catch (error) {
    yield put(MOActions.updateMOStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_STATUS_MO.ERROR, error));
  }
}

/**
 *
 */
function* updateMOStatus() {
  yield takeLatest(moActionTypes.UPDATE_STATUS_MO.REQUEST, _updateMOStatus);
}

/**
 * @param action
 */
function* _deleteMO(action) {
  try {
    yield put(MOActions.deleteMOLoading(true));
    const mo = yield MOServices.deleteMO(action.payload);

    if (mo.success) {
      notification.open({
        type: 'success',
        message: ' Manufacturing Order successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.deleteMOLoading(false));
  } catch (error) {
    yield put(MOActions.deleteMOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.DELETE_MO.ERROR, error));
  }
}

/**
 *
 */
function* deleteMO() {
  yield takeLatest(moActionTypes.DELETE_MO.REQUEST, _deleteMO);
}

/**
 * @param action
 */
function* _archiveMo(action) {
  try {
    yield put(MOActions.archiveMoLoading(true));
    const mo = yield MOServices.archiveMo(action.payload);

    if (mo.success) {
      notification.open({
        type: 'success',
        message: 'Manufacturing Order successfully archived',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.archiveMoLoading(false));
  } catch (error) {
    yield put(MOActions.archiveMoLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.ARCHIVE_MO.ERROR, error));
  }
}

/**
 *
 */
function* archiveMo() {
  yield takeLatest(moActionTypes.ARCHIVE_MO.REQUEST, _archiveMo);
}

/**
 * @param action
 */
function* _updateMOAdjustmentStatus(action) {
  try {
    yield put(MOActions.updateMOAdjustmentStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const mo = yield MOServices.updateMOAdjustmentStatus(payload);

    if (mo.success) {
      notification.open({
        type: 'success',
        message: 'Batch status updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.updateMOAdjustmentStatusLoading(false));
  } catch (error) {
    yield put(MOActions.updateMOAdjustmentStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MO_ADJUSTMENT_STATUS.ERROR, error));
  }
}

/**
 *
 */
function* updateMOAdjustmentStatus() {
  yield takeLatest(moActionTypes.UPDATE_MO_ADJUSTMENT_STATUS.REQUEST, _updateMOAdjustmentStatus);
}

function* _getMoJobWorks(action) {
  try {
    yield put(MOActions.getMoJobWorksLoading(true));
    const { payload, callback } = action;
    const jobWorks = yield MOServices.getMoJobWorks({
      mo_id: payload?.mo_id,
    });
    if (jobWorks.success) {
      if (callback) {
        callback();
      }
      yield put(MOActions.getMoJobWorksSuccess(jobWorks?.data));
    } else {
      notification.open({
        type: 'error',
        message: jobWorks.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.getMoJobWorksLoading(false));
  } catch (error) {
    yield put(MOActions.getMoJobWorksLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MO_JOB_WORKS.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getMoJobWorks() {
  yield takeLatest(moActionTypes.GET_MO_JOB_WORKS.REQUEST, _getMoJobWorks);
}

/**
 * @param action
 */
function* _getDownloadMO(action) {
  const {
    payload, callback,
  } = action;
  try {
    yield put(MOActions.getDownloadMOLoading(true));
    const moData = yield MOServices.getDownloadMO(payload?.type, payload?.emails, payload?.tenantId, payload?.status, payload?.searchKeyword, payload?.fromDate, payload?.toDate, payload?.sellerId, payload?.departmentId, payload?.isArchived, true, payload?.scheduledStartDate, payload?.scheduledEndDate, payload?.userId, payload?.source, payload?.customerId, payload?.salesOrderNumber);
    if (moData?.success) {
      notification.open({
        type: 'success',
        message: 'Your request is being processed. You will receive the data on your email once ready.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: moData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.getDownloadMOLoading(false));
  } catch (error) {
    yield put(MOActions.getDownloadMOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_DOWNLOAD_MO.ERROR, error));
  }
}

function* getDownloadMO() {
  yield takeLatest(moActionTypes.GET_DOWNLOAD_MO.REQUEST, _getDownloadMO);
}

/**
 * @param action
 */
function* _addRM(action) {
  try {
    yield put(MOActions.addRMLoading(true));
    const mo = yield MOServices.addRM(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.ADD_RM.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Added Raw Material Successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(mo?.data);
      }
      yield put(MOActions.addRMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.addRMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.addRMLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.ADD_RM.ERROR, error));
  }
}

/**
 *
 */
function* addRM() {
  yield takeLatest(moActionTypes.ADD_RM.REQUEST, _addRM);
}

/**
 * @param action
 */
function* _removeRM(action) {
  try {
    yield put(MOActions.removeRMLoading(true));
    const mo = yield MOServices.removeRM(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.REMOVE_RM.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Removed Raw Material successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(mo?.data);
      } yield put(MOActions.removeRMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.removeRMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.removeRMLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.REMOVE_RM.ERROR, error));
  }
}

/**
 *
 */
function* removeRM() {
  yield takeLatest(moActionTypes.REMOVE_RM.REQUEST, _removeRM);
}

/**
 * @param action
 */
function* _swapRM(action) {
  try {
    yield put(MOActions.swapRMLoading(true));
    const mo = yield MOServices.swapRM(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(moActionTypes.SWAP_RM.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Removed Raw Material successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(mo?.data);
      } yield put(MOActions.swapRMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.swapRMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(MOActions.swapRMLoading(false));
    yield put(TrackerActions.trackAction(moActionTypes.SWAP_RM.ERROR, error));
  }
}

/**
 *
 */
function* swapRM() {
  yield takeLatest(moActionTypes.SWAP_RM.REQUEST, _swapRM);
}

function* _getWorkOrderRm(action) {
  try {
    MOActions.getWorkOrderRmSuccess(null);
    yield put(MOActions.getWorkOrderRmLoading(true));
    const { payload, callback } = action;
    const workOrderRm = yield MOServices.getWorkOrderRm(payload.moId, payload.fgTenantProductId);
    yield put(MOActions.getWorkOrderRmSuccess(workOrderRm));
    if (callback) {
      callback(workOrderRm?.data);
    }
    yield put(MOActions.getWorkOrderRmLoading(false));
  } catch (error) {
    yield put(MOActions.getWorkOrderRmLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_WORK_ORDER_RM.ERROR, error));
  }
}

function* getWorkOrderRm() {
  yield takeLatest(moActionTypes.GET_WORK_ORDER_RM.REQUEST, _getWorkOrderRm);
}

function* _getMasterProductionProcess(action) {
  try {
    MOActions.getMasterProductionProcessSuccess(null);
    yield put(MOActions.getMasterProductionProcessLoading(true));
    const { payload, callback } = action;
    const masterProductionProcess = yield MOServices.getMasterProductionProcess(payload.moId);
    yield put(MOActions.getMasterProductionProcessSuccess(masterProductionProcess));
    if (callback) {
      callback(masterProductionProcess);
    }
    yield put(MOActions.getMasterProductionProcessLoading(false));
  } catch (error) {
    yield put(MOActions.getMasterProductionProcessLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to fetch Master Production Process',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MASTER_PRODUCTION_PROCESS.ERROR, error));
  }
}

function* getMasterProductionProcess() {
  yield takeLatest(moActionTypes.GET_MASTER_PRODUCTION_PROCESS.REQUEST, _getMasterProductionProcess);
}

function* _updateMasterProductionProcess(action) {
  try {
    MOActions.updateMasterProductionProcessSuccess(null);
    yield put(MOActions.updateMasterProductionProcessLoading(true));
    const { payload, callback } = action;
    const updateMasterProductionProcess = yield MOServices.updateMasterProductionProcess(payload);
    yield put(MOActions.updateMasterProductionProcessSuccess(updateMasterProductionProcess));
    if (updateMasterProductionProcess?.success) {
      notification.open({
        type: 'success',
        message: 'Master Production Process updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(updateMasterProductionProcess?.data);
      }
      yield put(MOActions.updateMasterProductionProcessLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: updateMasterProductionProcess?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(MOActions.updateMasterProductionProcessLoading(false));
    }
  } catch (error) {
    yield put(MOActions.updateMasterProductionProcessLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to update Master Production Process',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.UPDATE_MASTER_PRODUCTION_PROCESS.ERROR, error));
  }
}

function* updateMasterProductionProcess() {
  yield takeLatest(moActionTypes.UPDATE_MASTER_PRODUCTION_PROCESS.REQUEST, _updateMasterProductionProcess);
}

function* _getMasterProductionSchedule(action) {
  try {
    MOActions.getMasterProductionScheduleSuccess(null);
    yield put(MOActions.getMasterProductionScheduleLoading(true));
    const { payload, callback } = action;
    const masterProductionSchedule = yield MOServices.getMasterProductionSchedule(payload.moId);
    yield put(MOActions.getMasterProductionScheduleSuccess(masterProductionSchedule));
    if (callback) {
      callback(masterProductionSchedule);
    }
    yield put(MOActions.getMasterProductionScheduleLoading(false));
  } catch (error) {
    yield put(MOActions.getMasterProductionScheduleLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to fetch Master Production Schedule',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MASTER_PRODUCTION_SCHEDULE.ERROR, error));
  }
}

function* getMasterProductionSchedule() {
  yield takeLatest(moActionTypes.GET_MASTER_PRODUCTION_SCHEDULE.REQUEST, _getMasterProductionSchedule);
}

function* _getMachineSchedule(action) {
  try {
    MOActions.getMachineScheduleSuccess(null);
    yield put(MOActions.getMachineScheduleLoading(true));
    const { payload, callback } = action;
    const machineSchedule = yield MOServices.getMachineSchedule(payload);
    yield put(MOActions.getMachineScheduleSuccess(machineSchedule));
    if (callback) {
      callback(machineSchedule);
    }
    yield put(MOActions.getMachineScheduleLoading(false));
  } catch (error) {
    yield put(MOActions.getMachineScheduleLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to fetch Machine Schedule',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GET_MACHINE_SCHEDULE.ERROR, error));
  }
}

function* getMachineSchedule() {
  yield takeLatest(moActionTypes.GET_MACHINE_SCHEDULE.REQUEST, _getMachineSchedule);
}

function* _scheduleMachine(action) {
  try {
    MOActions.scheduleMachineSuccess(null);
    yield put(MOActions.scheduleMachineLoading(true));
    const { payload, callback } = action;
    const scheduleMachine = yield MOServices.scheduleMachine(payload);
    yield put(MOActions.scheduleMachineSuccess(scheduleMachine));
    if (scheduleMachine?.success) {
      notification.open({
        type: 'success',
        message: 'Machine scheduled successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: scheduleMachine?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.scheduleMachineLoading(false));
  } catch (error) {
    yield put(MOActions.scheduleMachineLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to schedule Machine',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.SCHEDULE_MACHINE.ERROR, error));
  }
}

function* scheduleMachine() {
  yield takeLatest(moActionTypes.SCHEDULE_MACHINE.REQUEST, _scheduleMachine);
}

function* _recalculateProductionSchedule(action) {
  try {
    MOActions.recalculateProductionScheduleSuccess(null);
    yield put(MOActions.recalculateProductionScheduleLoading(true));
    const { payload, callback } = action;
    const recalculateProductionSchedule = yield MOServices.recalculateProductionSchedule(payload);
    yield put(MOActions.recalculateProductionScheduleSuccess(recalculateProductionSchedule));
    if (recalculateProductionSchedule?.success) {
      if (callback) {
        callback(recalculateProductionSchedule);
      }
    } else {
      notification.open({
        type: 'error',
        message: recalculateProductionSchedule?.message ?? 'Unable to recalculate Production Schedule',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.recalculateProductionScheduleLoading(false));
  } catch (error) {
    yield put(MOActions.recalculateProductionScheduleLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to recalculate Production Schedule',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.RECALCULATE_PRODUCTION_SCHEDULE.ERROR, error));
  }
}

function* recalculateProductionSchedule() {
  yield takeLatest(moActionTypes.RECALCULATE_PRODUCTION_SCHEDULE.REQUEST, _recalculateProductionSchedule);
}

function* _deleteMachineSchedule(action) {
  try {
    MOActions.deleteMachineScheduleSuccess(null);
    yield put(MOActions.deleteMachineScheduleLoading(true));
    const { payload, callback } = action;
    const deleteMachineSchedule = yield MOServices.deleteMachineSchedule(payload);
    yield put(MOActions.deleteMachineScheduleSuccess(deleteMachineSchedule));
    if (deleteMachineSchedule?.success) {
      notification.open({
        type: 'success',
        message: 'Machine Schedule deleted successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(deleteMachineSchedule);
      }
    } else {
      notification.open({
        type: 'error',
        message: deleteMachineSchedule?.message ?? 'Unable to delete Machine Schedule',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.deleteMachineScheduleLoading(false));
  } catch (error) {
    yield put(MOActions.deleteMachineScheduleLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to delete Machine Schedule',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.DELETE_MACHINE_SCHEDULE.ERROR, error));
  }
}

function* deleteMachineSchedule() {
  yield takeLatest(moActionTypes.DELETE_MACHINE_SCHEDULE.REQUEST, _deleteMachineSchedule);
}

function* _generateSlip(action) {
  try {
    MOActions.generateSlipSuccess(null);
    yield put(MOActions.generateSlipLoading(true));
    const { payload, callback } = action;
    const generateSlip = yield MOServices.generateSlip(payload);
    yield put(MOActions.generateSlipSuccess(generateSlip));
    if (generateSlip?.success) {
      if (callback) {
        callback(generateSlip);
      }
    } else {
      notification.open({
        type: 'error',
        message: generateSlip?.message ?? 'Unable to generate Slip',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.generateSlipLoading(false));
  } catch (error) {
    yield put(MOActions.generateSlipLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to generate Slip',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.GENERATE_SLIP.ERROR, error));
  }
}

function* generateSlip() {
  yield takeLatest(moActionTypes.GENERATE_SLIP.REQUEST, _generateSlip);
}

function* _bulkGenerateSlip(action) {
  try {
    MOActions.bulkGenerateSlipSuccess(null);
    yield put(MOActions.bulkGenerateSlipLoading(true));
    const { payload, callback } = action;
    const bulkGenerateSlip = yield MOServices.bulkGenerateSlip(payload);
    yield put(MOActions.bulkGenerateSlipSuccess(bulkGenerateSlip));
    if (bulkGenerateSlip?.success) {
      if (callback) {
        callback(bulkGenerateSlip);
      }
    } else {
      notification.open({
        type: 'error',
        message: bulkGenerateSlip?.message ?? 'Unable to bulk generate Slip',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MOActions.bulkGenerateSlipLoading(false));
  } catch (error) {
    yield put(MOActions.bulkGenerateSlipLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Unable to bulk generate Slip',
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(moActionTypes.BULK_GENERATE_SLIP.ERROR, error));
  }
}

function* bulkGenerateSlip() {
  yield takeLatest(moActionTypes.BULK_GENERATE_SLIP.REQUEST, _bulkGenerateSlip);
}

/**
 *
 */
export default function* moSaga() {
  yield all([
    createMO(), getMO(), updateMO(), getMOById(), updateMOStatus(),
    deleteMO(), archiveMo(), createMOAdjustment(), updateMOAdjustmentStatus(),
    updateMOOtherCharges(), getMoJobWorks(),
    getDownloadMO(), addRM(), removeRM(), swapRM(), getWorkOrderRm(),
    getMasterProductionProcess(), updateMasterProductionProcess(),
    getMasterProductionSchedule(), getMachineSchedule(), scheduleMachine(),
    recalculateProductionSchedule(),
    deleteMachineSchedule(),
    generateSlip(),
    bulkGenerateSlip(),
  ]);
}
